import React from "react";

// const isDev = process.env.NODE_ENV === "development";
const isDev = true;

/**
 * AdBanner - Renders a placeholder container for AdSense banner ads.
 *
 * The native app fills this container by calling window.pushAdFromNative()
 * with the ad config (adClient, adSlot, size, divId).
 *
 * - Collapses to zero height when no ad is loaded.
 * - In dev mode, shows a dashed border + label so you can spot the ad slot.
 *
 * Props:
 *   - divId (string, required): Unique ID for the ad container, must match the divId sent by native.
 *   - style (object): Additional inline styles for the container.
 */
const AdBanner = ({ divId, style = {} }) => {
    return (
        <div
            id={divId}
            style={{
                width: "100%",
                minHeight: isDev ? "60px" : 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "10px auto",
                ...(isDev ? {
                    border: "1px dashed rgba(255, 255, 255, 0.4)",
                    borderRadius: "4px",
                    background: "linear-gradient(135deg, rgba(44,83,145,0.3), rgba(100,60,180,0.2))",
                    fontSize: "11px",
                    color: "rgba(255, 255, 255, 0.5)",
                } : {}),
                ...style,
            }}
        >
            {isDev && `Ad Slot: ${divId}`}
        </div>
    );
};

export default AdBanner;
